import { render, staticRenderFns } from "./DashboardHoliday.vue?vue&type=template&id=37f6d854&scoped=true"
import script from "./DashboardHoliday.vue?vue&type=script&lang=js"
export * from "./DashboardHoliday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6d854",
  null
  
)

export default component.exports